import { WidgetChartData } from '@/dashboard/shared/types/widgets.types';
import { computed, ComputedRef } from 'vue';
import { ReferenceChartData } from './referenceSettingOption.setup';

export const useReferenceChartDataList = (widgetChartDataList: ComputedRef<WidgetChartData[]>) => {
  const referenceChartDataList = computed<ReferenceChartData[]>(() => {
    return widgetChartDataList.value
      .filter(({ category, dataId }) => !!category && !!dataId)
      .map(({ category, dataId }, chartDataIndex) => ({
        type: 'stat',
        chartDataIndex,
        statId: dataId,
        category,
      }));
  });

  return { referenceChartDataList };
};
